import React, { useRef, useEffect } from 'react';
import ChatInterface from '../components/ChatInterface';
import { streamKnowledgeChat } from '../services/knowledgeService';
import { useModel } from '../contexts/ModelContext';
import { useAuth } from '../contexts/AuthContext';
import { logInteraction } from '../services/adminService';

function KnowledgeChat({ registerChatReset }) {
  const chatRef = useRef(null);
  const { selectedModel } = useModel();
  const { userEmail, userProfile } = useAuth();
  const sessionIdRef = useRef('knowledge-' + Date.now());

  useEffect(() => {
    if (registerChatReset && chatRef.current) {
      registerChatReset('/knowledge/chat', () => {
        chatRef.current.reset();
        sessionIdRef.current = 'knowledge-' + Date.now();
      });
    }
  }, [registerChatReset]);

  const handleSendMessage = async (question, conversationHistory, onMessage, onError, onComplete) => {
    await streamKnowledgeChat(question, conversationHistory, onMessage, onError, onComplete, selectedModel, userEmail, userProfile, sessionIdRef.current);
  };

  const handleLogInteraction = async (data) => {
    await logInteraction({
      ...data,
      session_id: sessionIdRef.current,
      context_type: 'knowledge',
      model_key: selectedModel,
    });
  };

  return (
    <ChatInterface 
      ref={chatRef}
      onSendMessage={handleSendMessage}
      onLogInteraction={handleLogInteraction}
      placeholder="Search knowledge base..."
      title="Knowledge Agent"
      agentTitle="KNOWLEDGE AGENT"
    />
  );
}

export default KnowledgeChat;
